import api from '@api/apiServices';
import { Autocomplete, TextField } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type AddContactToGroupProps = {
    control: Control<FieldValues>;
};

const AddContactToGroup = (props: AddContactToGroupProps) => {
    const { control } = props;
    const { t } = useTranslation();

    const { data, isLoading } = useQuery({
        queryKey: ['groups', 'dropdown'],
        queryFn: () => api.contacts.groups.get({ all: true }),
        placeholderData: [],
    });

    return (
        <Controller
            name="group"
            control={control}
            render={({ field: { onChange, ...restField } }) => (
                <Autocomplete
                    options={data}
                    loading={isLoading}
                    getOptionLabel={option => option.name}
                    onChange={(event, newValue) => onChange(newValue)}
                    {...restField}
                    renderInput={params => (
                        <TextField
                            margin="dense"
                            {...params}
                            label={t('Select Group')}
                        />
                    )}
                />
            )}
        />
    );
};

export default AddContactToGroup;
